export default "__VITE_PUBLIC_ASSET__93facdf1__"